import React from "react";
import StaticPage from "./StaticPage";

export default function Terms() {
  return (
    <StaticPage
      eyebrow="Legal"
      title="Terms of Service"
      updated="February 2026"
      testId="page-terms"
    >
      <p>
        These Terms of Service (&quot;Terms&quot;) govern access to and use of SenseWise (the
        &quot;Service&quot;), provided by <strong>Occuthera</strong>. By creating an account or using the
        Service you agree to these Terms.
      </p>

      <h2>1. Description of the Service</h2>
      <p>SenseWise is a sensory self-regulation companion built on Ayres Sensory Integration and Winnie
        Dunn&apos;s Sensory Processing Model. It offers curated intervention bubbles grouped by sensory
        system and by core feelings for use by therapists, educators, students, and their families.</p>
      <p><strong>Not a medical device.</strong> SenseWise is an educational and clinical-support tool.
        It is not a medical device and does not provide medical diagnosis or treatment. It is not a
        substitute for professional occupational therapy, psychological, medical, or emergency care.</p>

      <h2>2. Accounts &amp; eligibility</h2>
      <p>Therapist and administrator accounts must be created by licensed or supervised professionals,
        or by school-district staff, aged 18 or older. Student accounts are created by an authorized
        therapist or administrator on behalf of the student.</p>

      <h2>3. Acceptable use</h2>
      <p>You agree not to (a) reverse-engineer or copy the Service; (b) upload content that is unlawful,
        harmful, or infringing; (c) attempt to access another user&apos;s data; (d) use the Service to
        provide emergency crisis care; or (e) interfere with the security or performance of the Service.</p>

      <h2>4. School district &amp; enterprise use</h2>
      <p>Where the Service is used by a school district or clinical organization under a written
        services agreement or Data Processing Addendum, the terms of that agreement control in the event
        of any conflict with these Terms.</p>

      <h2>5. Content &amp; intellectual property</h2>
      <p>The name &quot;SenseWise&quot;, the Occuthera brand, the intervention library, and the user
        interface are the intellectual property of Occuthera. You are granted a limited, non-exclusive,
        non-transferable license to use the Service for its intended clinical and educational purposes.</p>

      <h2>6. Feedback</h2>
      <p>If you send us feedback or suggestions, you grant Occuthera a perpetual, royalty-free license
        to use that feedback to improve the Service.</p>

      <h2>7. Disclaimers</h2>
      <p>The Service is provided <strong>&quot;as is&quot;</strong> and <strong>&quot;as available&quot;</strong>
        without warranties of any kind, whether express or implied, including warranties of
        merchantability, fitness for a particular purpose, or non-infringement.</p>

      <h2>8. Limitation of liability</h2>
      <p>To the fullest extent permitted by law, Occuthera will not be liable for any indirect,
        incidental, special, consequential, or punitive damages arising from your use of the Service.
        Occuthera&apos;s total liability for any claim relating to the Service will not exceed the
        amount you paid for the Service in the 12 months preceding the claim, or one hundred U.S.
        dollars ($100), whichever is greater.</p>

      <h2>9. Termination</h2>
      <p>You may stop using the Service at any time. We may suspend or terminate access if you violate
        these Terms. Provisions that by their nature survive termination (IP, disclaimers, liability)
        will survive.</p>

      <h2>10. Governing law</h2>
      <p>These Terms are governed by the laws of the United States and the state in which Occuthera is
        headquartered, without regard to conflict-of-laws principles.</p>

      <h2>11. Changes</h2>
      <p>We may update these Terms from time to time. Continued use of the Service after changes
        become effective constitutes acceptance of the updated Terms.</p>

      <h2>12. Contact</h2>
      <p>Questions? <a href="mailto:Hello@occuthera.com">Hello@occuthera.com</a></p>
    </StaticPage>
  );
}
